export const fields = [
  {
    id: 'firstName',
    label: 'Prénom',
    type: 'text',
    defaultValue: '',
  },
  {
    id: 'lastName',
    label: 'Nom',
    type: 'text',
    defaultValue: '',
  },
  {
    id: 'email',
    label: 'Email',
    type: 'text',
    defaultValue: '',
  },
  {
    id: 'username',
    label: "Nom d'utilisateur",
    type: 'text',
    defaultValue: '',
  },
  {
    id: 'password',
    label: 'Mot de passe',
    type: 'password',
    defaultValue: '',
  },
];

export const DEFAULT_VALUES = fields.reduce(
  (prev, curr) => ({ ...prev, [curr.id]: curr.defaultValue }),
  { modules: [] },
);
